<template>
  <template v-if="projects.length"
    ><Item v-for="project in projects" :key="project.slug" :project="project"
  /></template>
  <div v-else :class="$style.empty">Нет проектов :(</div>
</template>

<script>
import Item from "./Item.vue";
export default {
  components: {
    Item,
  },
  computed: {
    projects() {
      return this.$store.state.projects.projects;
    },
  },
};
</script>

<style lang="scss" module>
.empty {
  text-align: center;
  padding: 2rem 0 0.5rem 0;
  color: $t-secondary;
}
</style>
